import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  layerParent: {
    ...StyleSheet.absoluteFillObject,
    overflow: 'hidden',
  },
  imagePosition: {
    position: 'absolute',
  },
});
